<template>
<div>
	<base-modal :show="showLoginForm" @close="showLoginForm = false" title="Login">
		<login-form @showLoginForm="closeLoginForm" @component-key="componentKey"></login-form>
	</base-modal>
	<nav class="navbar navbar-expand-lg navbar-dark px-5" style="background-color: #263238">
		<div class="container-fluid">
			<a class="navbar-brand" href="#">six4three</a>
			<button
				class="navbar-toggler"
				type="button"
				data-bs-toggle="collapse"
				data-bs-target="#navbarText"
				aria-controls="navbarText"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon"><i class="fas fa-bars"></i></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarText">
				<ul class="navbar-nav me-auto mb-2 mb-lg-0">
					<!-- <li class="nav-item">
						<router-link class="nav-link" to="/">Home</router-link>
					</li> -->
					<li v-if="isAuth" class="nav-item">
						<router-link class="nav-link" href="#" to="/discussions">Dugout Talk</router-link>
					</li>
					<li v-if="isAuth" class="nav-item dropdown">
						<a
							class="nav-link dropdown-toggle"
							href="#"
							id="navbarDropdown"
							role="button"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							League
						</a>
						<ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="navbarDropdown">
							<li>
								<router-link disabled class="dropdown-item" href="" to=""> League Page </router-link>
							</li>
							<li>
								<router-link v-if=" getUserType !== 'League Manager'" class="dropdown-item" href="" to="/team-page"> Team Page </router-link>
							</li>
						</ul>
					</li>
					<li v-if="isAuth && (getUserType === 'Coach' || getUserType === 'League Manager')" class="nav-item dropdown">
						<a
							class="nav-link dropdown-toggle"
							href="#"
							id="navbarDropdown"
							role="button"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							Manage
						</a>
						<ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="navbarDropdown">
							<li v-if="getUserType === 'League Manager'">
								<router-link class="dropdown-item" href="" to="/manage-league">
									League Dashboard
								</router-link>
							</li>
							<li v-if="getUserType === 'Coach'">
								<router-link class="dropdown-item" href="" to="/manage-team"> Manage Team </router-link>
							</li>
						</ul>
					</li>
				</ul>
				<span>
					<ul class="navbar-nav me-auto mb-2 mb-lg-0">
						<li v-if="isAuth" class="nav-item dropdown position-relative">
							<a
								class="nav-link dropdown-toggle"
								href="#"
								id="navbarDropdown"
								role="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<span v-if="notifications === 'true'" class="position-absolute top-50 start-0 translate-middle p-1 bg-info border border-info rounded-circle"></span> Hello {{ firstName }}
							</a>
							<ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="navbarDropdown">
								<li>
									<router-link class="dropdown-item" href="#" to="/profile">Profile</router-link>
								</li>
								<li><router-link class="dropdown-item" href="#" to="/notifications" >Notifications <span v-show="notificationCount > 0" class="badge bg-info">{{ notificationCount }}</span></router-link></li>
								<li><a class="dropdown-item" href="#">Team Page</a></li>
								<li><hr class="dropdown-divider" /></li>
								<li>
									<a class="dropdown-item" href="#" @click="logout">Log Out</a>
								</li>
							</ul>
						</li>
						<li v-else-if="!isDiscussion" class="nav-item">
							<a
								href="#"
								class="nav-link"
								@click="showLoginForm = true"
								>Login</a
							>
						</li>
						<li v-if="!isAuth" class="nav-item">
							<router-link class="nav-link" to="SignUp">Sign Up</router-link>
						</li>
					</ul>
				</span>
			</div>
		</div>
	</nav>
	<div v-show="loggedOut" class="alert alert-info alert-dismissible fade show mt-3 mx-5" role="alert">
		You have logged out!
		<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
	</div>
</div>
</template>

<script>
import LoginForm from '@/components/auth/LoginForm.vue';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default {
	components: {
		LoginForm,
	},
	setup() {
		const store = useStore();
		const route = useRoute();
		const router = useRouter();

		const showLoginForm = ref(false);
		const loggedOut = ref(false);
		const isAuth = computed(() => store.getters.isAuthenticated);
		const firstName = computed(() => store.getters.userFName);
		const getUserType = computed(() => store.getters.userType);
		const isDiscussion = computed(() => route.name === 'Discussions');
		const isSignUp = computed(() => route.name === 'Discussions');
		const exit = ref(false)
		const notifications = computed(() => store.getters['notifications/getNotificationStatus'])
		const loadNotifications = computed(() => store.getters['notifications/getNotificatons'])
		const notificationCount = computed(() => store.getters['notifications/getNotificationCount'])

		const closeLoginForm = (event) => {
			exit.value = true
			setTimeout(() => {
				showLoginForm.value = event.value;
			},1000)
			
		};
		const resetNotifications = () => {
			store.dispatch('boards/resetNotifications')
		}
		const logout = () => {
			store.dispatch('logout');
			router.push('/');
			loggedOut.value = true;
			setTimeout(() => {
				loggedOut.value = false
			}, 5000);
		};
		const componentKey = () => {
			setTimeout(() => {
				router.go();
			}, 1000);
		};

		return {
			showLoginForm,
			closeLoginForm,
			isAuth,
			logout,
			firstName,
			isDiscussion,
			isSignUp,
			getUserType,
			componentKey,
			loggedOut,
			exit,
			notifications,
			resetNotifications,
			loadNotifications,
			notificationCount
		};
	},
};
</script>
